import React, { useState } from 'react'
import Modal from 'aldoo-ra/Modal'
import Typography from 'aldoo-ra/Typography'
import Button from 'aldoo-ra/Button'
import Input from 'aldoo-ra/Input'
import DropdownSelect from 'aldoo-ra/DropdownSelect'
import { showNotification } from 'aldoo-ra/Notification'
import { LANGUAGE_OPTIONS } from '../../constants'
import SubscriberController from '../controllers/SubscriberController'

const AddSubscriberDialog = ({ isOpen, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    email: "",
    userName: "",
    language: "en",
    platforms: ["web"],
  })

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!formData.email) {
      showNotification({
        message: "Validation Error: Email address is required",
        className: "bg-admin_error text-white",
      })
      return
    }

    setLoading(true)
    const subscriberData = {
      email: formData.email,
      name: formData.userName,
      language: formData.language,
      platforms: formData.platforms
    }

    const response = await SubscriberController.addSubscriber(subscriberData)
    setLoading(false)

    if (response.success) {
      onSuccess()
      onClose()
      setFormData({
        email: "",
        userName: "",
        language: "en",
        platforms: ["web"],
      })
    } else {
      let errorTitle = "Error"

      switch (response.error) {
        case "EMAIL_EXISTS":
          errorTitle = "Duplicate Subscriber"
          break
        case "INVALID_EMAIL":
          errorTitle = "Invalid Email"
          break
        case "MISSING_EMAIL":
          errorTitle = "Missing Email"
          break
        case "SERVER_ERROR":
          errorTitle = "Server Error"
          break
        default:
          errorTitle = "Error"
      }

      showNotification({
        message: `${errorTitle}: ${response.message || "Failed to add subscriber"}`,
        className: "bg-admin_error text-white",
      })
    }
  }

  const handleClose = () => {
    if (!loading) {
      onClose()
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      variant="admin_compact"
      className="max-w-md"
    >
      <form onSubmit={handleSubmit}>
        <div className="p-6 pb-8">
          <Typography
            component="h1"
            variant="admin_h3"
            className="mb-6"
          >
            Add Subscriber
          </Typography>

          <div>
            <div>
              <Typography
                variant="admin_label"
                className="mb-1"
              >
                Email Address *
              </Typography>

              <Input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                placeholder="subscriber@example.com"
                required
                disabled={loading}
              />
            </div>

            <div className="mt-4">
              <Typography
                variant="admin_label"
                className="mb-1"
              >
                Name (Optional)
              </Typography>

              <Input
                type="text"
                value={formData.userName}
                onChange={(e) => setFormData({ ...formData, userName: e.target.value })}
                placeholder="John Doe"
                disabled={loading}
              />
            </div>

            <div className="mt-4">
              <Typography
                variant="admin_label"
                className="mb-1"
              >
                Language
              </Typography>

              <DropdownSelect
                variant="admin"
                searchEnabled={true}
                fixedWidth="100%"
                valueField="code"
                showCheckbox={false}
                value={LANGUAGE_OPTIONS.filter(lang => lang.code === formData.language)}
                onChange={(values) => {
                  const selectedValue = values?.[0]?.code || "en"
                  setFormData({ ...formData, language: selectedValue })
                }}
                options={LANGUAGE_OPTIONS}
                placeholder="Select language..."
                disabled={loading}
              />
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end space-x-3 p-6">
          <Button
            variant="admin_secondary"
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </Button>

          <Button
            type="submit"
            variant="admin_primary"
            loading={loading}
          >
            Add Subscriber
          </Button>
        </div>
      </form>
    </Modal>
  )
}

export default AddSubscriberDialog
